import { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if user has already consented to cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Small delay to show popup after page loads
      setTimeout(() => {
        setShowPopup(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowPopup(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-white rounded-lg shadow-2xl border-2 border-gray-200 z-40 max-w-sm p-4 animate-slide-up">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-2">
          <Cookie className="text-yellow-accent" size={20} />
          <h3 className="font-bold text-gray-dark text-sm">Cookie Consent</h3>
        </div>
        <button
          onClick={handleDecline}
          className="text-gray-400 hover:text-gray-dark transition-colors"
          aria-label="Close"
        >
          <X size={18} />
        </button>
      </div>
      
      <p className="text-xs text-gray-light leading-relaxed mb-4">
        We use cookies to enhance your browsing experience and analyze site traffic. By clicking 
        "Accept", you consent to our use of cookies.{' '}
        <Link to="/cookie-policy" data-discover="true" className="text-yellow-accent hover:underline">
          Learn more
        </Link>
      </p>

      <div className="flex gap-2">
        <button
          onClick={handleAccept}
          className="flex-1 bg-yellow-accent text-gray-dark py-2 px-4 rounded-lg font-semibold text-xs hover:bg-yellow-light transition-colors"
        >
          Accept
        </button>
        <button
          onClick={handleDecline}
          className="flex-1 border border-gray-300 text-gray-dark py-2 px-4 rounded-lg font-semibold text-xs hover:bg-gray-50 transition-colors"
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;

